/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable no-useless-escape */
import React, { useState, useEffect, useRef } from "react";
import { Spinner, Container } from "reactstrap";
import Header from './../../components/HeaderNoLogin';
import { getContractByID, sendSignature } from './../../api/request';

export default function Contract() {
  const window_screen = window.screen.width;
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState('');
  const [id, setId] = useState('');
  const canvasRef = useRef(null);
  const [error, setError] = useState(false);

  useEffect(() => {
    getContract();
  }, []);

  const getContract = async () => {
    const key = new URLSearchParams(window.location.search).get('k');

    if (key === null || key === undefined || key === '') {
      window.location.href = '/';
      return;
    }
    else {
      const res = await getContractByID(key);

      if (res.success === true) {
        const pdfData = 'data:application/pdf;base64,' + res.data;
        setId(key);
        setData(pdfData);
      }
      else {
        setError(true);
        alert(res.message);
      }
    }
    setLoading(false);
  }

  const initializeCanvas = (canvas) => {
    if (!canvas) return;

    const ctx = canvas.getContext("2d");
    ctx.lineWidth = 2; // Ajusta el grosor del trazo
    ctx.strokeStyle = "#000"; // Color del trazo

    let isDrawing = false;

    // Funciones para mouse
    const startDrawing = (e) => {
      isDrawing = true;
      ctx.beginPath();
      ctx.moveTo(e.offsetX, e.offsetY);
    };

    const draw = (e) => {
      if (!isDrawing) return;
      ctx.lineTo(e.offsetX, e.offsetY);
      ctx.stroke();
    };

    const stopDrawing = () => {
      isDrawing = false;
      ctx.closePath();
    };

    // Funciones para touch
    const getTouchPos = (canvas, touchEvent) => {
      const rect = canvas.getBoundingClientRect();
      const touch = touchEvent.touches[0] || touchEvent.changedTouches[0];
      return {
      x: touch.clientX - rect.left,
      y: touch.clientY - rect.top
      };
    };

    const startTouchDrawing = (e) => {
      e.preventDefault();
      isDrawing = true;
      const pos = getTouchPos(canvas, e);
      ctx.beginPath();
      ctx.moveTo(pos.x, pos.y);
    };

    const touchDraw = (e) => {
      if (!isDrawing) return;
      e.preventDefault();
      const pos = getTouchPos(canvas, e);
      ctx.lineTo(pos.x, pos.y);
      ctx.stroke();
    };

    const stopTouchDrawing = (e) => {
      if (!isDrawing) return;
      e.preventDefault();
      isDrawing = false;
      ctx.closePath();
    };

    // Mouse events
    canvas.addEventListener("mousedown", startDrawing);
    canvas.addEventListener("mousemove", draw);
    canvas.addEventListener("mouseup", stopDrawing);
    canvas.addEventListener("mouseout", stopDrawing);

    // Touch events
    canvas.addEventListener("touchstart", startTouchDrawing, { passive: false });
    canvas.addEventListener("touchmove", touchDraw, { passive: false });
    canvas.addEventListener("touchend", stopTouchDrawing, { passive: false });
    canvas.addEventListener("touchcancel", stopTouchDrawing, { passive: false });

    return () => {
      canvas.removeEventListener("mousedown", startDrawing);
      canvas.removeEventListener("mousemove", draw);
      canvas.removeEventListener("mouseup", stopDrawing);
      canvas.removeEventListener("mouseout", stopDrawing);

      canvas.removeEventListener("touchstart", startTouchDrawing);
      canvas.removeEventListener("touchmove", touchDraw);
      canvas.removeEventListener("touchend", stopTouchDrawing);
      canvas.removeEventListener("touchcancel", stopTouchDrawing);
    };
  };

  useEffect(() => {
    const canvas = canvasRef.current;
    const cleanup = initializeCanvas(canvas);

    return () => {
      if (cleanup) cleanup();
    };
  }, []);

  const signatureFunc = async () => {
    const canvas = canvasRef.current;
    if (!canvas) {
      alert("No se pudo obtener la firma. Por favor, intente nuevamente.");
      return;
    }
    const signature = canvas.toDataURL("image/png");
    console.log("Signature Data URL:", signature);

    const formData = new FormData();
    formData.append("signature", signature);
    formData.append("key", id);

    // Enviar la firma al servidor
    const res = await sendSignature(formData);

    if (res.success === true) {
      alert("El documento se ha firmado correctamente");
    } else {
      alert("Error al firmar el documento");
    }
  }

  return (
    <>
      <Header bottom />
      <Container>
        {
          error ? <></> : <h2>Contrato</h2>
        }

        {
          (loading) ?
            <>
              <div className="text-center">
                <Spinner style={{ color: '#004899' }} />
              </div>
            </>
            :
            <>
            {
              error ?
                <div className="text-center">
                  <h4>El contrato ya fue procesado</h4>
                  <p>Por favor, contacte a su ejecutivo de ventas para más información.</p>
                  <a href="https://visionarygroup.la/"> Regresar </a>
                </div>
                :
                <>
                  <object
                    data={data}
                    type="application/pdf"
                    width="100%"
                    height={window_screen > 768 ? "500px" : "400px"}
                    className="pdf-viewer"
                  ></object>

                  <div className="signature-container">
                    <br />
                    <h4>Firma</h4>
                    <canvas
                      ref={canvasRef}
                      id="signature-pad"
                      width={window_screen > 768 ? 600 : 300}
                      height={200}
                      style={{
                        border: "1px solid #ccc",
                        display: "block",
                        margin: "10px auto",
                      }}
                    ></canvas>
                    <div className="text-center">
                      <button
                        className="btn btn-primary"
                        onClick={() => initializeCanvas(canvasRef.current)}
                        style={{ marginRight: "10px" }}
                      >
                        Activar Firma
                      </button>
                      <button
                        className="btn btn-primary"
                        onClick={() => signatureFunc()}
                      >
                        Guardar Firma
                      </button>
                      <button
                        className="btn btn-secondary"
                        onClick={() => {
                          const canvas = document.getElementById("signature-pad");
                          const ctx = canvas.getContext("2d");
                          ctx.clearRect(0, 0, canvas.width, canvas.height);
                        }}
                        style={{ marginLeft: "10px" }}
                      >
                        Limpiar
                      </button>
                    </div>
                  </div>

                  <br />
                  <br />
                </>
            }
            </>
        }
      </Container>
    </>
  )
}

